const menuRouter = [
    /**
     * 采购管理
     **/
    {
        path: '/statistics/billprobybill',
        meta: { title: '出入库分类细统计' },
        component: () => import('@/views/page/statistics/billprobybill'),
        used: true,
    },
    {
        path: '/statistics/billprobybilltype',
        meta: { title: '按账单汇总物品' },
        component: () => import('@/views/page/statistics/billprobybilltype'),
        used: true,
    },
    {
        path: '/statistics/billprobybptype',
        meta: { title: '出入库分类粗统计' },
        component: () => import('@/views/page/statistics/billprobybptype'),
        used: true,
    },
    {
        path: '/statistics/billprobymonth',
        meta: { title: '物资收发存汇总' },
        component: () => import('@/views/page/statistics/billprobymonth'),
        used: true,
    },
    {
        path: '/statistics/billprobyyear',
        meta: { title: '物资年明细帐' },
        component: () => import('@/views/page/statistics/billprobyyear'),
        used: true,
    },
    {
        path: '/statistics/billprodystock',
        meta: { title: '物资收发存明细' },
        component: () => import('@/views/page/statistics/billprodystock'),
        used: true,
    },
    {
        path: '/statistics/billproflow',
        meta: { title: '物资流水帐' },
        component: () => import('@/views/page/statistics/billproflow'),
        used: true,
    },
    {
        path: '/statistics/productflow',
        meta: { title: '物资流向' },
        component: () => import('@/views/page/statistics/productflow'),
        used: true,
    },
    {
        path: '/statistics/billproinouttotal',
        meta: { title: '物资出入库统计' },
        component: () => import('@/views/page/statistics/billproinouttotal'),
        used: true,
    },
    {
        path: '/statistics/billpropricediff',
        meta: { title: '统计两极差价格' },
        component: () => import('@/views/page/statistics/billpropricediff'),
        used: true,
    },
    {
        path: '/statistics/productito',
        meta: { title: '统计库存周转率' },
        component: () => import('@/views/page/statistics/productito'),
        used: true,
    },
    {
        path: '/statistics/statisticsbill',
        meta: { title: '账单汇总统计' },
        component: () => import('@/views/page/statistics/statisticsbill'),
        used: true,
    },
    {
        path: '/statistics/productdetail',
        meta: { title: '物资库存明细表' },
        component: () => import('@/views/page/statistics/productdetail'),
        used: true,
    },
    {
        path: '/statistics/producttotal',
        meta: { title: '物资总计' },
        component: () => import('@/views/page/statistics/producttotal'),
        used: true,
    },
    {
        path: '/statistics/productwarning',
        meta: { title: '库存预警' },
        component: () => import('@/views/page/statistics/productwarning'),
        used: true,
    },
    {
        path: '/statistics/productidle',
        meta: { title: '库存呆料' },
        component: () => import('@/views/page/statistics/productidle'),
        used: true,
    },
    {
        path: '/statistics/productbytype',
        meta: { title: '库存分类统计' },
        component: () => import('@/views/page/statistics/productbytype'),
        used: true,
    },
    {
        path: '/statistics/productmonth',
        meta: { title: '库存月报表' },
        component: () => import('@/views/page/statistics/productmonth'),
        used: true,
    },
    {
        path: '/statistics/billprobyproject',
        meta: { title: '项目汇总统计' },
        component: () => import('@/views/page/statistics/billprobyproject'),
        used: true,
    }
]

export default menuRouter
